import { Dayjs } from 'dayjs';

declare module 'dayjs' {
    export interface Dayjs {
        formatIf(format: string, invalidValue?: string): string;
        toISOStringIf(invalidValue?: string): string;
    }
}

export default function (option: null, dayjsClass: typeof Dayjs) {
    // Override original dayjs functions to be a bit
    // more relaxed when a date is invalid:
    const origFormat = dayjsClass.prototype.format;
    const origToISOString = dayjsClass.prototype.toISOString;

    /**
     * adds a default response string if the date is invalid, instead of an error
     */
    dayjsClass.prototype.formatIf = function (format, invalidValue = '') {
        if (this.isValid()) {
            return origFormat.call(this, format);
        } else {
            return invalidValue;
        }
    };

    /**
     * adds a default response string if the date is invalid, instead of an error
     */
    dayjsClass.prototype.toISOStringIf = function (invalidValue = '') {
        if (this.isValid()) {
            return origToISOString.call(this);
        } else {
            return invalidValue;
        }
    };
}
